import React from 'react';
import styles from './TopTab.module.scss';
import Status from './components/status/Status';
import TimeLeft from './components/timeLeft/TimeLeft';

export interface ISectionProps {
  hideStatus?: boolean;
  className?: string;
}

const TopTab = ({hideStatus, className, ...props}: ISectionProps) => {
  return hideStatus ? (null) : (
    <div className={`${styles.TopTab} ${className}`.trim()}>
      <TimeLeft {...props}/>
      <Status {...props}/>
    </div>
  );
};

TopTab.defaultProps = {
  className: '',
  hideStatus: false,
};
export default TopTab;
